export function consoleMessage() {
  console.log(
    "Well, you found the console. I bet you're looking for bugs, huh?"
  );
  console.log("If you find any, shhh... let's keep it between us!");
}
